exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".library-wrapper {\n  padding-left: 240px;\n  transition: padding-left 0.4s ease; }\n  .library-wrapper.library-hidden {\n    padding-left: 0; }\n  .library-wrapper.prevent-interaction {\n    pointer-events: none; }\n  .library-wrapper .walkthrough-target {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    right: 65px; }\n\ntog-image-library {\n  position: absolute;\n  left: 0;\n  height: 100%; }\n\n.hide-library {\n  position: absolute;\n  bottom: 88px;\n  margin-left: 11px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: left;\n  color: #5b6779;\n  cursor: pointer; }\n  .hide-library img {\n    margin-top: -2px;\n    margin-right: 4px; }\n  .hide-library.library-hidden img {\n    transform: scaleX(-1); }\n\n.cancel-btn {\n  width: 111px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/image-library-cropper-modal/image-library-cropper-modal.component.scss
// module id = ../../../../../src/app/shared/components/image-library-cropper-modal/image-library-cropper-modal.component.scss
// module chunks = 12